/* eslint-disable */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from '@/translations/en'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: { en }
})

const loadedLanguages = ['en'] // our default language that is preloaded

function setI18nLanguage (lang: string) {
  i18n.locale = lang
  document.querySelector('html')?.setAttribute('lang', lang)
  return lang
}

export function loadLanguageAsync (lang: string) {
  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      return import(`@/translations/${lang}`).then(strings => {
        i18n.setLocaleMessage(lang, strings.default)
        loadedLanguages.push(lang)
        return setI18nLanguage(lang)
      })
    }
    return Promise.resolve(setI18nLanguage(lang))
  }
  return Promise.resolve(lang)
}

export default i18n
